"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("@antv/util");
var base_1 = require("./base");
var point_1 = require("./shape/point");
/**
 * Point 类型的几何图形
 * 绘制散点图
 */
var Point = /** @class */ (function (_super) {
    tslib_1.__extends(Point, _super);
    function Point(cfg) {
        var _this = _super.call(this, tslib_1.__assign({ type: 'point', shapeType: 'point', generatePoints: true, shareTooltip: false }, cfg)) || this;
        // 每一个 Element 对应一个确定的 shapeFactory
        _this.set('shapeFactory', point_1.default);
        return _this;
    }
    // overwrite
    Point.prototype.drawPoint = function (obj, container, shapeFactory, index) {
        var _this = this;
        var shape = obj.shape;
        var cfg = this.getDrawCfg(obj);
        if (_.isArray(obj.y)) {
            var hasStackAdjust_1 = this.hasAdjust('stack');
            _.each(obj.y, function (y, idx) {
                cfg.y = y;
                cfg.yIndex = idx;
                if (!hasStackAdjust_1 || idx !== 0) {
                    var geomShape = shapeFactory.drawShape(shape, cfg, container);
                    _this.appendShapeInfo(geomShape, index + idx);
                }
            });
        }
        else if (!_.isNil(obj.y)) {
            var geomShape = shapeFactory.drawShape(shape, cfg, container);
            this.appendShapeInfo(geomShape, index);
        }
    };
    return Point;
}(base_1.default));
exports.default = Point;
//# sourceMappingURL=point.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/point.js
// module id = 599
// module chunks = 37